import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Swallow html5-qrcode's benign camera-teardown rejection so it never surfaces
// as an app-level error (dev overlay / logs).
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (e) => {
    const msg = (e && e.reason && (e.reason.message || e.reason)) || "";
    if (typeof msg === "string" && msg.includes("play() request was interrupted")) {
      e.preventDefault();
    }
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
